/**
 * @ngdoc directive
 * @name input message
 *
 * @scope
 * @param {Object} options - optional object that will get input options
 *
 * @example
 <input-message options={message: 'error'}>
 */
(function () {
  inputMessage.$inject = ["PATH"];
  app.directive('inputMessage', inputMessage);

  function inputMessage (PATH) {
    return {
      restrict: 'E',
      templateUrl: PATH.components + 'inputMessage/inputMessage.tpl.html',
      scope: {
        options: '='
      }
    };
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/inputMessage/inputMessageDirective.js